import { httpBus } from "@/api/index.js";


/**
 * 获取电表的分析数据
 * >>> 电表的有功无功和因数历史曲线
 * @param {*} stationId 
 * @param {*} uuid 
 * @param {*} startTime 
 * @param {*} endTime 
 * @returns 
 */
export function queryMeterAnalysisData({stationId, uuid, startTime, endTime}) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryMeterPowerHistory`, {
    params: {
      stationId,
      equipmentUUID: uuid,
      startTime,
      endTime
    }
  });
}





